import { render, staticRenderFns } from "./VueScriptComponent.vue?vue&type=template&id=f55794c8&scoped=true&"
import script from "./VueScriptComponent.vue?vue&type=script&lang=js&"
export * from "./VueScriptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55794c8",
  null
  
)

export default component.exports